module.exports = __webpack_public_path__ + "img/avatar3.085e8d73.png";